class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');

    // after this.checkbox add a div with class za-checkbox
    const div = document.createElement('div');
    div.classList.add('za-checkbox');
    this.checkbox.after(div);
    
  }
 }

customElements.define('contact-form', ContactForm);